"use strict";

if (!Array.prototype.find) {
  require("./array.find");
}


//////////////////
// WEBPACK FOOTER
// ./~/material-table/dist/utils/polyfill/index.js
// module id = 1229
// module chunks = 0